function getLinkPathname(href: string): string | null {
  if (!href.startsWith("/") || href.startsWith("//")) return null;
  const path = href.split(/[?#]/)[0];
  return path.length > 1 ? path.replace(/\/$/, "") : path;
}

export function isPathnameMatch(pathname: string, href: string) {
  const normalizedHref = getLinkPathname(href);
  if (!normalizedHref) return false;
  return (
    pathname === normalizedHref || pathname.startsWith(`${normalizedHref}/`)
  );
}

export function findMostSpecificPathMatch<T extends { href: string }>(
  pathname: string,
  items: readonly T[],
) {
  const seenHrefs = new Set<string>();
  let bestMatch: T | null = null;
  let bestMatchLength = 0;

  for (const item of items) {
    const normalizedHref = getLinkPathname(item.href);
    if (!normalizedHref) continue;

    if (seenHrefs.has(normalizedHref)) {
      throw new Error(`Duplicate PageSubNav href: ${normalizedHref}`);
    }
    seenHrefs.add(normalizedHref);

    if (
      isPathnameMatch(pathname, normalizedHref) &&
      normalizedHref.length > bestMatchLength
    ) {
      bestMatch = item;
      bestMatchLength = normalizedHref.length;
    }
  }

  return bestMatch;
}
